import meta from "./publicRoadmap/meta.json";
import en from "./publicRoadmap/en.json";
import de from "./publicRoadmap/de.json";
import es from "./publicRoadmap/es.json";
import fr from "./publicRoadmap/fr.json";
import ar from "./publicRoadmap/ar.json";

const locales = { en, de, es, fr, ar };

const publicRoadmapContent = {
  ...meta,
  locales,
};

export default publicRoadmapContent;
